export const DRIFT_STAKE_VOTER_PLUGIN =
  'dVoTE1AJqkZVoE1mPbWcqYPmEEvAUBksHY2NiM2UJQe'

export const DRIFT_PROGRAM_ID = 'dRiftyHA39MWEi3m9aunc5MzRF1JYuBsbn6VPcn33UH'

//export const DRIFT_GOVERNANCE_PROGRAM_ID = 'dgov7NC8iaumWw3k8TkmLDybvZBCmd1qwxgLAGAsWxf'

export const DRIFT_GOVERNANCE_TICKER = 'DRFT'
